import { render, staticRenderFns } from "./ShipmentCostCalculate.vue?vue&type=template&id=58a82f76&scoped=true&"
import script from "./ShipmentCostCalculate.vue?vue&type=script&lang=ts&"
export * from "./ShipmentCostCalculate.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentCostCalculate.vue?vue&type=style&index=0&id=58a82f76&lang=scss&scoped=true&"
import style1 from "./ShipmentCostCalculate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a82f76",
  null
  
)

export default component.exports